import { useState } from "react"
import { graphql, useMutation } from "react-relay"

import { useSyncIntegrationMutation as Mutation } from "./__generated__/useSyncIntegrationMutation.graphql"

type SyncOptions = {
  integrationId: number
  forceSyncMerge?: boolean
}

const useSyncIntegration = () => {
  const [commit] = useMutation<Mutation>(graphql`
    mutation useSyncIntegrationMutation($input: IntegrationSyncInput!) {
      syncIntegration(input: $input) {
        integration {
          id
          state
          last_sync_at
          next_sync_at
        }
      }
    }
  `)

  const [isInFlight, setIsInFlight] = useState(false)

  const onSync = (options: SyncOptions): Promise<void> => {
    setIsInFlight(true)
    return new Promise((resolve, reject) => {
      commit({
        variables: {
          input: {
            integration_id: options.integrationId,
            force_sync_merge: options.forceSyncMerge,
          },
        },
        onCompleted: () => {
          // wait 1 second to simulate network request
          setTimeout(() => {
            setIsInFlight(false)
            resolve(undefined)
          }, 1000)
        },
        onError: (error) => {
          setIsInFlight(false)
          reject(error)
        },
      })
    })
  }

  return [onSync, isInFlight] as const
}

export { useSyncIntegration }
